import { render } from "./LandingNavbar.vue?vue&type=template&id=5e797d70&scoped=true"
import script from "./LandingNavbar.vue?vue&type=script&lang=js"
export * from "./LandingNavbar.vue?vue&type=script&lang=js"

import "./LandingNavbar.vue?vue&type=style&index=0&id=5e797d70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e797d70"]])

export default __exports__